/* eslint-disable global-require */
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router";
import { Layout, Menu, LocaleProvider, Icon } from "antd";
import zh_CN from "antd/lib/locale-provider/zh_CN";
import { layout } from "icsoc-antd-ex";
import IconFont from "Components/common/iconFont";
import tCommonActions from "Actions/common";
import tLoginActions from "Actions/login";
import ajax from "Utils/ajax";

import avatar from "Static/images/default_avatar.jpg";
import logo from "Static/images/logo.png";
import { getParam, removeCookie } from "Utils";
import CommonContent from "./layOut/commonContent/index";

if (process.env.JS_ENV === "development") {
  require("./app_local.less");
} else {
  require("./app.less");
}

const { Content } = Layout;
const { BaseHeader, BaseSider } = layout;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userName: "",
    };

    this.handelChangeCollapsed = this.handelChangeCollapsed.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  componentDidMount() {
    const { loginActions, login, commonActions } = this.props;
    // 是否是单页嵌入
    const spa = getParam("spa") === "1";
    commonActions.setSpa(spa);
    commonActions.getSideNav();

    const openid = sessionStorage.getItem("openid");
    // 刷新页面若使用weixin登录则再次获取token
    // 定时刷新access_token
    if (openid) {
      setInterval(() => {
        loginActions
          .refreshAccessToken({
            openid,
          })
          .then(() => {
            const {
              refreshTokenInfo: {
                data: { access_token, expires_in = null } = {},
              } = {},
            } =
              login || {};
            if (access_token) {
              sessionStorage.setItem("token", access_token);
              if (expires_in) {
                sessionStorage.setItem("expires_in", expires_in);
              }

              ajax.defaults.headers.common["access-token-id"] = access_token;
            }
          });
      }, 60 * 60 * 1000);
    }
    loginActions.setPermissions();
    if (window.localStorage.getItem("user")) {
      const user = JSON.parse(window.localStorage.getItem("user"));
      const userName = user.profile?.user_name || "";
      this.setState({ userName });
      loginActions.setPermissions();
    }
  }

  handelChangeCollapsed() {
    const { common: { collapsed } = {}, commonActions } = this.props;

    commonActions.toggleSider(!collapsed);
  }

  signOut() {
    // eslint-disable-next-line no-underscore-dangle
    const accoutHost = window.__config.account
    const { origin } = window.location;
    window.localStorage.setItem("user", "");
    window.localStorage.setItem("customize", "");
    removeCookie("ekt_access_token");
    // 注意：退出时的地址要和 oauth/index.jsx 中的保持同步
    window.location.href = `${accoutHost}/logout?post_logout_redirect_uri=${origin}/oauth`
  }

  render() {
    const {
      children,
      common: { collapsed, menuList, spa = false } = {},
      pathname,
    } = this.props;
    const { userName } = this.state;
    // 右侧头部下啦
    const menu = (
      <Menu>
        <Menu.Item>
          <Link to="/" onClick={this.signOut}>
            <Icon type="poweroff" />
            <span style={{ marginLeft: 8 }}>退出系统</span>
          </Link>
        </Menu.Item>
      </Menu>
    );
    const selectedKeys =
      pathname.split("/")[1] || menuList[0].path.split("/")[1];

    const getCollapsePaddingLeft = () => {
      if (spa) {
        return 0;
      }
      return !collapsed
        ? "180px"
        : selectedKeys === "newRoleManage" || selectedKeys === "userManage"
          ? "0"
          : "60px";
    };

    return (
      <LocaleProvider locale={zh_CN}>
        <div className="container antdx">
          <Layout
            style={{
              height: "100%",
              background: menuList === null ? "#fff" : "#f0f2f5",
            }}
          >
            {!spa &&
            menuList !== null &&
            menuList.length !== 0 &&
            selectedKeys !== "newRoleManage" &&
            selectedKeys !== "userManage" ? (
              <BaseSider
                appName={userName}
                appLogo={logo}
                collapsed={collapsed}
                selectedKeys={selectedKeys}
              >
                {menuList.map((item) => {
                  return (
                    <Menu.Item key={item.code}>
                      <Link to={item.children[0].to}>
                        <IconFont type={item.iconName} />
                        <span>{item.name}</span>
                      </Link>
                    </Menu.Item>
                  );
                })}
              </BaseSider>
            ) : null}
            <Layout
              style={{
                background: menuList === null ? "#fff" : "#f0f2f5",
                paddingLeft: `${getCollapsePaddingLeft()}`,
              }}
            >
              {!spa &&
              selectedKeys !== "newRoleManage" &&
              selectedKeys !== "userManage" ? (
                <BaseHeader
                  className={
                    menuList === null || menuList.length === 0
                      ? "longerHeader"
                      : ""
                  }
                  // className='longerHeader'
                  onToggleSideBtn={this.handelChangeCollapsed}
                  avatarUrl={avatar}
                  userName={userName}
                  userMenu={menu}
                />
              ) : null}
              <Content
                style={{
                  paddingTop: `${
                    spa ||
                    selectedKeys === "newRoleManage" ||
                    selectedKeys === "userManage"
                      ? "0"
                      : "60px"
                  }`,
                }}
                className="main-content"
              >
                {menuList !== null ? (
                  <CommonContent spa={spa}>{children}</CommonContent>
                ) : (
                  <div style={{ width: "100%", height: "100%" }}>
                    <div className="noLimits">
                      <img src="./../static/images/img-no limits.png" alt="" />
                      <div>无访问权限</div>
                    </div>
                  </div>
                )}
              </Content>
            </Layout>
          </Layout>
        </div>
      </LocaleProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    common: state.common,
    pathname: state.routing.locationBeforeTransitions.pathname,
    login: state.login,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(tCommonActions, dispatch),
    loginActions: bindActionCreators(tLoginActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
